import React from "react";
import PropTypes from "prop-types";

export default function Close2(props) {
  return (
    <svg
      onClick={props.onClick}
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M18 0.888889L17.1111 0L9 8.11111L0.888889 0L0 0.888889L8.11111 9L0 17.1111L0.888889 18L9 9.88889L17.1111 18L18 17.1111L9.88889 9L18 0.888889Z"
        fill={props.fill}
      />
    </svg>
  );
}

Close2.propTypes = {
  className: PropTypes.string,
  fill: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number,
  onClick: PropTypes.func
};

Close2.defaultProps = {
  className: "",
  fill: "#CAD9E8",
  width: 18,
  height: 18,
  onClick: () => null
};
